<template>
  <div class="hi-lo-number">
    <Row class="hi-lo-number-container" type="flex">
      <new-bet-lot
        v-for="item in gameRow1"
        class="hi-lo-number-betlot"
        :type="item"
        :win="winCellNo === item"
        :odd="odd(item)"
        gameType="hi_lo"
        game="number-bet"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
        size="small"
      />
    </Row>
    <div class="hi-lo-number-section-divider"></div>
    <Row class="hi-lo-number-container" type="flex">
      <new-bet-lot
        v-for="item in gameRow2"
        class="hi-lo-number-betlot"
        :type="item"
        :win="winCellNo === item"
        :odd="odd(item)"
        gameType="hi_lo"
        game="number-bet"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
        size="small"
      />
    </Row>
    <div class="hi-lo-number-section-divider"></div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["winCellNo", "game", "gameData"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      gameRow1: ["o102", "o103", "o104", "o105", "o106", "o107"],
      gameRow2: ["o108", "o109", "o110", "o111", "o112", "o101"]
    };
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.hi-lo-number {
  @extend .game-section;
}

.hi-lo-number-section-divider {
  height: 5px;
}

.hi-lo-number-betlot {
  // position: relative;
  flex: 1;
  margin: 0 2px;
}

.hi-lo-number-betlot:first-of-type {
  margin-left: unset;
}

.hi-lo-number-betlot:last-of-type {
  margin-right: unset;
}

.hi-lo-number-cell {
  position: relative;
  padding: 0;
  flex: 3.42857143;
  padding-top: 6px;
  padding-bottom: 6px;
}

.hi-lo-number-cell:first-of-type {
  margin-left: unset;
}

.hi-lo-number-cell:last-of-type {
  margin-right: unset;
}

.hi-lo-number-title {
  @extend .tai-xiu-game-title;
}

.hi-lo-number-bet-no {
  @extend .tai-xiu-game-bet-no;
  margin-top: unset;
}

.hi-lo-number-cell.ivu-btn:before {
  content: "";
  display: block;
  top: 0;
  height: 31%;
  z-index: 0;
}

@media only screen and (max-width: 360px) {
  .hi-lo-number-bet-no {
    margin-top: 5px;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.hi-lo-number-cell.ivu-btn {
  @extend .tai-xiu-game-btn;
}

.hi-lo-number-cell.ivu-btn:hover .hi-lo-number-title,
.hi-lo-number-cell.ivu-btn:hover .hi-lo-number-bet-no {
  @extend .tai-xiu-game-btn-hover-cell;
}

.hi-lo-number-cell.ivu-btn:focus {
  @extend .tai-xiu-game-btn-focus;
}

.hi-lo-number-cell.hi-lo-number-cell-active.ivu-btn .hi-lo-number-title,
.hi-lo-number-cell.hi-lo-number-cell-active.ivu-btn .hi-lo-number-bet-no {
  @extend .tai-xiu-game-btn-active;
}

.hi-lo-number-cell.ivu-btn:hover {
  @extend .tai-xiu-game-btn-hover;
}
</style>
